// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ClsModelsEnumsServiceType } from './clsModelsEnumsServiceType.js';
import type { IAttachment } from './iAttachment.js';
import type { IConsent } from './iConsent.js';
import type { IPatient } from './iPatient.js';
import type { IPayor } from './iPayor.js';
import type { IPharmacyPayor } from './iPharmacyPayor.js';
import type { IPrescriber } from './iPrescriber.js';
import type { IPrescription } from './iPrescription.js';
import type { ISite } from './iSite.js';
import type { ISurvey } from './iSurvey.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class IClsEnrollmentRequest {
    'callingTransactionId'?: string;
    'callingTransactionType'?: string;
    'caseSource': string;
    'programCode': string;
    'productFamily': string;
    'diagnosisCodes'?: Array<string>;
    'preferredPharmacy'?: Array<string>;
    'servicesNeeded'?: Array<ClsModelsEnumsServiceType>;
    'mercalisHubId'?: string;
    'thirdPartyHubId'?: string;
    'thirdPartyCaseId'?: string;
    'patient': IPatient | null;
    'medicalPayors'?: Array<IPayor>;
    'pharmacyPayors'?: Array<IPharmacyPayor>;
    'surveys'?: Array<ISurvey>;
    'socSites'?: Array<ISite>;
    'sites'?: Array<ISite>;
    'prescriptions'?: Array<IPrescription>;
    'prescribers'?: Array<IPrescriber>;
    'consent'?: Array<IConsent>;
    'attachments'?: Array<IAttachment>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof IClsEnrollmentRequest>> = [
        {
            "name":     "callingTransactionId",
            "baseName": "callingTransactionId",
            "type":     "string"
        },
        {
            "name":     "callingTransactionType",
            "baseName": "callingTransactionType",
            "type":     "string"
        },
        {
            "name":     "caseSource",
            "baseName": "caseSource",
            "type":     "string"
        },
        {
            "name":     "programCode",
            "baseName": "programCode",
            "type":     "string"
        },
        {
            "name":     "productFamily",
            "baseName": "productFamily",
            "type":     "string"
        },
        {
            "name":     "diagnosisCodes",
            "baseName": "diagnosisCodes",
            "type":     "Array<string>"
        },
        {
            "name":     "preferredPharmacy",
            "baseName": "preferredPharmacy",
            "type":     "Array<string>"
        },
        {
            "name":     "servicesNeeded",
            "baseName": "servicesNeeded",
            "type":     "Array<>"
        },
        {
            "name":     "mercalisHubId",
            "baseName": "mercalisHubId",
            "type":     "string"
        },
        {
            "name":     "thirdPartyHubId",
            "baseName": "thirdPartyHubId",
            "type":     "string"
        },
        {
            "name":     "thirdPartyCaseId",
            "baseName": "thirdPartyCaseId",
            "type":     "string"
        },
        {
            "name":     "patient",
            "baseName": "patient",
            "type":     "IPatient"
        },
        {
            "name":     "medicalPayors",
            "baseName": "medicalPayors",
            "type":     "Array<IPayor>"
        },
        {
            "name":     "pharmacyPayors",
            "baseName": "pharmacyPayors",
            "type":     "Array<IPharmacyPayor>"
        },
        {
            "name":     "surveys",
            "baseName": "surveys",
            "type":     "Array<ISurvey>"
        },
        {
            "name":     "socSites",
            "baseName": "socSites",
            "type":     "Array<ISite>"
        },
        {
            "name":     "sites",
            "baseName": "sites",
            "type":     "Array<ISite>"
        },
        {
            "name":     "prescriptions",
            "baseName": "prescriptions",
            "type":     "Array<IPrescription>"
        },
        {
            "name":     "prescribers",
            "baseName": "prescribers",
            "type":     "Array<IPrescriber>"
        },
        {
            "name":     "consent",
            "baseName": "consent",
            "type":     "Array<IConsent>"
        },
        {
            "name":     "attachments",
            "baseName": "attachments",
            "type":     "Array<IAttachment>"
        },
    ];

    static getAttributeTypeMap() {
        return IClsEnrollmentRequest.attributeTypeMap;
    }
}
